import { axiosInstance } from ".."

const getFeedBack = async (projetId,data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`internal/pm/feedback/${projetId}`,data).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default getFeedBack;